import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../i18n/LocaleContext'
import { getPrivacyPath } from '../utils/routes'
import { track } from '../lib/analytics'

// Newsletter signup. When VITE_MAILCHIMP_URL (a Mailchimp embedded-form action
// URL) is set, the form posts to Mailchimp in a new tab and double opt-in /
// unsubscribe / consent records are handled there. Until it's configured the
// form just shows a thank-you (placeholder), so the UI is ready to go live.
const texts = {
  hu: {
    placeholder: 'E-mail cím',
    button: 'Feliratkozom',
    consent: 'A feliratkozással elfogadod az',
    privacy: 'adatvédelmi irányelveket',
    success: 'Köszönjük! Értesítünk, amint indulnak az új táborok.',
  },
  ro: {
    placeholder: 'Adresă de email',
    button: 'Mă abonez',
    consent: 'Prin abonare accepți',
    privacy: 'politica de confidențialitate',
    success: 'Mulțumim! Te anunțăm imediat ce încep noile tabere.',
  },
}

export default function Newsletter() {
  const { locale } = useLocale()
  const t = texts[locale]
  const action = import.meta.env.VITE_MAILCHIMP_URL
  const [done, setDone] = useState(false)

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    track('newsletter_signup', { list: 'camp_reminders' })
    // No ESP configured yet → swallow the submit and show the thank-you.
    if (!action) {
      e.preventDefault()
      setDone(true)
    }
  }

  if (done) {
    return <p className="text-primary font-medium">{t.success}</p>
  }

  return (
    <form
      action={action || undefined}
      method="post"
      target={action ? '_blank' : undefined}
      onSubmit={handleSubmit}
      className="space-y-3"
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          name="EMAIL"
          required
          placeholder={t.placeholder}
          aria-label={t.placeholder}
          className="flex-1 px-4 py-3 rounded-btn border border-border focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-colors"
        />
        <button
          type="submit"
          className="px-6 py-3 rounded-btn bg-primary text-white font-medium hover:bg-primary-hover transition-colors"
        >
          {t.button}
        </button>
      </div>
      <p className="text-xs text-text-muted">
        {t.consent}{' '}
        <Link to={getPrivacyPath(locale)} className="underline hover:text-primary">
          {t.privacy}
        </Link>
        .
      </p>
    </form>
  )
}
